export default __webpack_public_path__ + "media/images/manual/joanr/13-9e9e553da2be97fb3a6f7512c85ee052.png";